<template>
  <div class="register-container">
    <!-- <div class="slider" :style="{ background: sliderImage1 }"> -->
    <img
      class="logo-cover"
      style="width: 150px"
      :src="require('../../assets/img/logo.png')"
    />
    <div class="slider slider1" v-if="slider == 'slider1'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li class="active"></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider2" v-if="slider == 'slider2'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li>
          <li class="active"></li>
          <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider3" v-if="slider == 'slider3'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li>
          <li></li>
          <li class="active"></li>
        </ul>
      </div>
    </div>

    <div class="form-side">
      <p class="alt-text">
        Don't have an account?
        <router-link class="signup-link" to="/auth/register"
          >Sign Up</router-link
        >
      </p>
      <!-- <h6 class="info_banner">
        <span class="important-text">Important Notice!</span> This platform
        closes Jan 6, 2025. Please switch to our mobile app
        <a
          href="https://apps.apple.com/us/app/arnergy-solarbase/id6469667753"
          class="app-link"
          target="_blank"
        >
          IOS</a
        ><span>|</span>
        <a
          href="https://play.google.com/store/apps/details?id=com.arnergy.mos"
          class="app-link"
          target="_blank"
        >
          Android
        </a>
      </h6> -->
      <div class="register-form">
        <div class="form-box">
          <div class="main-form-box">
            <div class="styled-header"></div>
            <form class="form-container" action="#">
              <h3>Enter your details</h3>
              <p>Kindly enter your details below!</p>

              <div class="input-box">
                <input
                  type="email"
                  v-bind:class="['input', loginErrors.email ? 'error' : '']"
                  placeholder="Email Address"
                  v-model="loginParams.email"
                  required
                />
                <small v-if="loginErrors.email" class="error">
                  {{ loginErrors.email }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="password"
                  v-bind:class="['input', loginErrors.password ? 'error' : '']"
                  placeholder="Password"
                  v-model="loginParams.password"
                  required
                />
                <small v-if="loginErrors.password" class="error">
                  {{ loginErrors.password }}
                </small>
              </div>
              <button v-if="loader" class="form-button">
                <div class="submit-gif">
                  <div
                    class="spinner-border"
                    style="width: 2rem; height: 2rem"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
              <button v-else @click="submitLogin" class="form-button">
                Login
              </button>
              <router-link class="signup-link" to="/auth/forgot-password"
                >Forgot Password?
              </router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import router from "../../router";
import ArnergyFormInput from "./kitchen/ArnergyFormInput";
import ArnergyLoader from "./kitchen/ArnergyLoader";

export default {
  name: "login",
  components: {
    ArnergyLoader,
    ArnergyFormInput
  },
  data() {
    return {
      bgColor: "../../assets/img/bg-image.jpg",
      loginParams: {
        email: null,
        password: null
      },
      slider: "slider1",
      sliderCount: 1,
      errors: {},
      loader: false,
      loginErrors: {},
      displayError: false,
      errorMessage: ""
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    ...mapActions(["setUserSession", "setAccess"]),
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },

    async setCurrent(user) {
      const HTTP = this.$httpUtils.FASTHTTP;
      try {
        const response = await HTTP.get(`/onboardingstate/state`);

        if (response.data.iscompleted || response.data.value) {
          var str = JSON.stringify(this.loginParams);
          const tempLogin = JSON.parse(str);
          // console.log({ tempLogin });
          if (tempLogin) {
            this.loader = true;
            this.loginLoopback(tempLogin);
          } else {
            this.loader = false;
          }
          // this.setAccessLocal(user);
        }
        // else if (
        //   response.data.currentPageName &&
        //   (response.data.currentPageName == "OnboardPaymentDeposit" ||
        //     response.data.currentPageName == "AwaitingContract" ||
        //     response.data.currentPageName == "OnboardContractUpload")
        // ) {
        //   await this.setAccessLocalOnboarding(response.data, user);
        //   // this.navTo(response.data.currentPageName);
        //   router.push("/onboarding/kyc-upload");
        // }
        // After BVNCheck has been done
        else if (
          response.data.currentPageName &&
          response.data.currentPageName == "OnboardContractUpload"
        ) {
          await this.setAccessLocalOnboarding(response.data, user);
          // this.navTo(response.data.currentPageName);
          router.push("/onboarding/kyc-upload");
        }
        // When cutomer has gotten to the Payment Page
        else if (
          response.data.currentPageName &&
          response.data.currentPageName == "PaymentUpload"
        ) {
          await this.setAccessLocalOnboarding(response.data, user);
          // this.navTo(response.data.currentPageName);
          router.push("/onboarding/payment-deposit");
        }
        // After Successful payment
        else if (
          response.data.currentPageName &&
          response.data.currentPageName == "AwaitingContract"
        ) {
          await this.setAccessLocalOnboarding(response.data, user);
          router.push("onboarding/contract-approval");
        } else if (response.data.stateid == 0) {
          await this.setAccessLocalOnboarding(response.data, user);
          router.push("/onboarding");
        } else {
          var str = JSON.stringify(this.loginParams);
          const tempLogin = JSON.parse(str);
          if (tempLogin) {
            this.loader = true;
            this.loginLoopback(tempLogin);
          } else {
            this.loader = false;
          }

          // this.setAccessLocal(user);
        }
      } catch (error) {
        console.log({ error });
        this.setAccessLocalCaseState(user);
      }
    },
    loginLoopback(tempLogin) {
      const HTTP = this.$httpUtils.instance;
      // ==================================
      HTTP.post("/users/login", tempLogin)
        .then(response => {
          var tkn = response.data.id;
          this.loader = false;

          HTTP.defaults.headers.common["Authorization"] = tkn;
          localStorage.setItem("appUserToken", tkn);

          HTTP.get(
            "/users/" +
              response.data.userId +
              `/?filter[include][role_mappings]/?${Date.now()}`,
            {}
          ).then(async userResponse => {
            this.loader = false;
            localStorage.uuid = userResponse.data.uuid;
            localStorage.firstName = userResponse.data.firstName;
            localStorage.lastName = userResponse.data.lastName;
            localStorage.customerId = userResponse.data.id;
            localStorage.phoneNumber = userResponse.data.phoneNumber;
            localStorage.email = userResponse.data.email;
            localStorage.roleType = userResponse.data.roleType;
            localStorage.userToken = userResponse.data.id;
            this.$store.state.loggedinUserRole = userResponse.data.roleType;

            var saveRole = [
              {
                subject: userResponse.data.roleType,
                actions: "all"
              }
            ];
            userResponse.data.token = tkn;
            userResponse.data.roleType = saveRole;
            this.setAccessLocal(userResponse.data);
          });
        })
        .catch(error => {
          console.log("error", error);
          const errorMessage =
            error && error.response && error.response.data
              ? error.response.data.error.message
              : "Unable to complete action, please try again";
          this.handleUnverifiedAccounts(errorMessage, this.loginParams.email);
          this.loader = false;
          this.showErrorMsg({
            message: errorMessage
          });
        });
    },
    validateLogin() {
      var err = [];
      for (let [field, value] of Object.entries(this.loginParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "email":
            if (value === "null" || value === "") {
              err[field] = "Email cannot be empty.";
            }
            break;
          case "password":
            if (value === "null" || value === "") {
              err[field] = "Password cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = err;
    },
    async getCurrentCustomerDeviceIds() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let url = `/installations?filter={"where":{"and": [{"userId":${userId}}, {"or":[{ "status": "requested"},{ "status": "commissioned"},{ "status": "completed"}]}]}}`;
      const result = await httpUtils.instance.get(url);
      return result.data;
    },
    submitLogin(e) {
      e.preventDefault();
      this.validateLogin();
      var errorLength = Object.keys(this.errors).length;

      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        this.showErrorMsg({
          message: this.errorMessage
        });
      } else {
        var str = JSON.stringify(this.loginParams);
        const tempLogin = JSON.parse(str);
        const HTTP = this.$httpUtils.FASTHTTP;
        const container = this;
        if (tempLogin) {
          this.loader = true;

          // ==================================
          HTTP.post("/auth/login", tempLogin)
            .then(response => {
              var tkn = response.data.access_token;
              this.loader = false;

              HTTP.defaults.headers.common["Authorization"] = "Bearer " + tkn;
              localStorage.setItem("appUserToken", tkn);
              localStorage.setItem("auth", tkn);
              localStorage.setItem("loginToken", tkn);
              HTTP.get("/auth/user").then(async userResponse => {
                this.loader = false;
                localStorage.firstName = userResponse.data.firstname;
                localStorage.lastName = userResponse.data.lastname;
                localStorage.customerId = userResponse.data.id;
                localStorage.phoneNumber = userResponse.data.phonenumber;
                localStorage.email = userResponse.data.email;
                localStorage.roleType = userResponse.data.roletype;
                localStorage.userToken = userResponse.data.access_token;
                this.$store.state.loggedinUserRole = userResponse.data.roletype;

                var saveRole = [
                  {
                    subject: userResponse.data.roletype,
                    actions: "all"
                  }
                ];
                userResponse.data.token = tkn;
                userResponse.data.roleType = saveRole;

                // GTM track user action
                if (this.isProduction()) {
                  this.$gtag.event("conversion", {
                    send_to: "AW-481803421/Fzm6CJS6pNIDEJ353uUB"
                  });
                }

                await this.setCurrent(userResponse.data);
              });
            })
            .catch(error => {
              console.log("error", error);
              this.loader = false;
              if (
                error.response &&
                error.response.data &&
                error.response.data.detail
              ) {
                const errorMessage = error.response.data.detail;
                this.showErrorMsg({
                  message: errorMessage
                });
              } else {
                this.showErrorMsg({
                  message: "An error occurred."
                });
              }
            });
        } else {
          this.loader = false;
        }
        // =========================
      }
    },
    handleUnverifiedAccounts(errorMessage, email) {
      const isUnverifiedAccount = errorMessage.includes("verified");
      if (!isUnverifiedAccount) return;

      const HTTP = this.$httpUtils.FASTHTTP;
      const data = { email: email };
      HTTP.post("/auth/send-verify-email", data)
        .then(res => {
          console.log({ res });
          this.navTo("EmailVerified", { email });
        })
        .catch(error => {
          console.log({ error });
        });
    },
    async setAccessLocal(userSession) {
      this.setUserSession(userSession);
      await this.$ability.update(userSession.roleType);
      let checkInstallation = await this.getCurrentCustomerDeviceIds();
      if (
        window.localStorage.roleType.toLowerCase() == "customer" &&
        Array.isArray(checkInstallation) &&
        checkInstallation.length === 0
      ) {
        router.push("/welcome").then(() => {
          router.go();
        });
      } else {
        // router.push("/");
        router.push("/").then(() => {
          router.go();
        });
        // router.go();
        // window.location.reload()
        // window.location.href = "/";
      }
    },
    async setAccessLocalOnboarding(onboardingLastState, userSession) {
      await this.setUserSession(userSession);
      // await this.$ability.update(userSession.roleType);
      // window.location.href = "/onboarding";
      // router.push("/onboarding");
      // router.push("/os/agreement");
      //await this.$ability.update(userSession.roleType);
      this.$store.commit("saveOnboardingCustomerState", onboardingLastState);
    },
    async setAccessLocalCaseState(userSession) {
      await this.setUserSession(userSession);
      await this.$ability.update(userSession.roleType);
      await router.push("/");
      window.location.reload();
    }
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  mounted() {
    setInterval(() => {
      this.slider = `slider${this.sliderCount}`;
      if (this.sliderCount === 3) this.sliderCount = 1;
      else this.sliderCount++;
    }, 3000);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_reduced_variables.scss";

h3,
p,
label,
ul,
li {
  margin: 0;
}

.register-container {
  width: 100%;
  background-color: white;
  display: flex;
}

.slider1 {
  background-image: url("../../assets/img/bg-image.jpg");
  transition: 1ms ease-in-out;
}

.slider2 {
  background-image: url("../../assets/img/slider-image-2.jpg");
  transition: 1ms ease-in-out;
}

.slider3 {
  background-image: url("../../assets/img/slider-image-3.jpg");
  transition: 1ms ease-in-out;
}

.slider {
  width: 60%;
  height: 100vh;
  padding-bottom: 4.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

img.logo-cover {
  position: absolute;
  top: 3.75rem;
  left: 3.75rem;
  z-index: 1;
}

.slider-base {
  width: 53%;
  text-align: center;
}

.slider-text > h3 {
  font-size: 1.5rem/2.5.5rem;
  margin-bottom: 0.625rem;
}

.slider-text > p {
  font-size: 1rem/1.5rem;
  margin-bottom: 2rem;
}

.slider-state {
  list-style-type: none;
  display: flex;
  width: fit-content;
  margin: 0 auto;
}

.slider-state li {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-right: 0.625rem;
  background-color: #dddddd;
  opacity: 0.5;
}

.slider-state li:last-child {
  margin-right: 0rem;
}

.slider-state li.active {
  width: 1.375rem;
  border-radius: 0.31rem;
  background-color: white;
}

.form-side {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex: 1;
  padding: 6rem 9rem;
  justify-content: center;
}

.register-form {
  color: #727272;
}

.form-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alt-text {
  font-size: 1.125rem/1.5rem;
  color: #727272;
  margin-left: auto;
  margin-bottom: 3.5rem;
}

.signup-link {
  color: #fe7a11;
}

.main-form-box {
  width: 100%;
  position: relative;
  z-index: 0;
}

/* .styled-header {
    background: #FDF9F5;
    width: 100%;
    height: 5rem;
    margin-bottom: -3rem;
    z-index: 1;
} */

.form-container {
  border-radius: 1.875rem 1.875rem 0rem 0rem;
  border: 0.1rem solid rgba(221, 221, 221, 0.5);
  width: 100%;
  height: fit-content;
  box-shadow: 0px 1.2rem 1.6rem rgba(16, 24, 40, 0.1),
    0px 0.4rem 0.6rem rgba(16, 24, 40, 0.05);
  padding: 3rem 7rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.form-container > h3 {
  font-weight: 700;
  font-size: 24px;
  line-height: 38.9px;
  color: #000000;
}

.form-container > p {
  font-size: 1.125rem/1.5rem;
  margin-bottom: 2.5rem;
  line-height: 24px;
}

.input-box {
  margin-bottom: 1.8rem;
  width: 100%;
}

.input-box:last-child {
  margin-bottom: 0rem;
  background-color: #727272;
}

.input-box input {
  width: 100%;
  border: 1px solid rgba(221, 221, 221, 0.5);
  padding: 14px 22px;
  height: 52px;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.5rem;
  color: #000000;
}

.input-box input:focus {
  border: 1px solid #0892d0;
}

.input-box input.error {
  border: 1px solid #f83c1e;
}

.input-box input::placeholder {
  color: #727272;
}

small.error {
  color: #f83c1e;
}

.input-box label {
  font-size: 16px;
  font-weight: 100;
  position: absolute;
  top: 1.5rem;
  left: 22px;
  color: #727272;
}

.form-button {
  padding: 0.875rem 3rem;
  border-radius: 5px;
  background-color: #0892d0;
  border: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  margin-top: 2.5rem;
  align-self: flex-end;
}

.form-button:hover {
  transform: scale(0.95);
}

.form-loader {
  align-self: flex-end;
}

.submit-gif {
  color: #ffffff;
  text-align: center;
  border: 0;
  background-color: transparent;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  width: 40%;
  max-width: 480px;
  margin: 105px auto;
  padding: 45px;
  background: #ffffff;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  font-family: "DM Sans";
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image {
  margin: 36px auto;
  width: 120px;
}

.logo {
  width: 125px;
}

b {
  font-weight: bold;
  font-family: inherit;
}

.submit-button {
  background: #0892d0;
  border-radius: 5px;
  width: 207px;
  height: 51px;
  margin: 31px auto;
  border: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
}

.close {
  margin: 0px 0px 0px auto;
}

.text {
  width: 90%;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  color: #727272;
  line-height: 24px;
}

.title {
  font-family: inherit;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
}

.max {
  background: rgba(233, 233, 233, 0.83);
}

@media (max-width: 1100px) {
  .register-container {
    width: 100%;
    height: 100vh;
    background-color: white;
  }
  .slider {
    display: none;
  }

  .form-side {
    .form-side {
      padding: 8px !important;
      overflow: hidden !important;
      background: white;
      margin: auto;
    }

    .form-container {
      padding: 2rem !important;
      width: 100%;
      background: white;
      background: white;
    }

    .slider-base {
      width: 80% !important;
    }

    .alt-text,
    .form-container,
    .slider-text > h3,
    .slider-text > p,
    .form-container > h3,
    .form-container > p,
    .input-box input::placeholder {
      font-size: 10px !important;
      margin-bottom: 8px !important;
    }

    .input-box input {
      height: 40px !important;
    }

    .alt-text {
      margin-top: 5px !important;
    }

    .form-container > h3 {
      margin: auto;
    }

    .form-button {
      font-size: 10px;
      line-height: 18px;
      margin-top: 10px;
    }
  }
}
.info_banner {
  font-size: 18px;
  padding: 10px;
  background-color: #016fb9;
  color: white;
  text-align: center;
  border-radius: 12px;
}

.important-text {
  font-weight: bold;
}

.app-link:hover,
.app-link {
  cursor: pointer;
  color: white;
  margin: 0 5px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue